import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  title: 'Descarga inmediata',
  desc: 'Recibes el acceso a tu PDF en tu correo apenas completes el pedido.'
}, {
  num: '2',
  title: 'Ve al Súper',
  desc: 'Usa la lista de compras para adquirir los ingredientes clave (muchos ya los tienes).'
}, {
  num: '3',
  title: 'Siente el cambio',
  desc: 'Elige una receta mañana mismo y nota cómo llegas al mediodía con energía y sin dolor.'
}];
export function HowItWorks() {
  return <section className="py-20 px-4 bg-light-sage" data-id="element-81">
      <div className="max-w-5xl mx-auto" data-id="element-82">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-16 text-sage" data-id="element-83">
          CÓMO FUNCIONA:
        </h2>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-84">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-sage/30 -z-10" data-id="element-85"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="flex flex-col items-center text-center" data-id="element-86">
              <div className="w-24 h-24 bg-white rounded-full shadow-warm flex items-center justify-center text-4xl font-bold text-sage mb-6 border-4 border-light-sage" data-id="element-87">
                {step.num}
              </div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-88">{step.title}</h3>
              <p className="text-lg text-espresso/80" data-id="element-89">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}